/* 
// JTM - RS  
// product builder calc scripts - Cover Builder
*/
//waitForElm('.product.js-product > .product-info.cd-builder-ready', true).then((elm) => {

///////////////////////////////////////////////////////////
// calculate total fabric yards - Cover Builders
function calaculateCoverFabricYardage(inputProductWidth, inputProductLength, inputProductHeight, inputMaterialFabricWidth, inputProductQuantity) {
  
    /*
    console.log("inputProductWidth",inputProductWidth);
    console.log("inputProductLength",inputProductLength);
    console.log("inputProductHeight",inputProductHeight);
    console.log("inputMaterialFabricWidth",inputMaterialFabricWidth);
    console.log("inputProductQuantity",inputProductQuantity);
    */
    /* the Square foot pricing and calculation for Furniture Covers.
    ((Height * Width * 2) + (Height * Length * 2) + (Width * Length)) / 144  */

    // size and fabric input field selector refernce goes here

    /*
        //const self = this;

        let inchesNeeded;
        let neededYardsPrecise;
        let neededYardsEstimated;

        let finishedwidth;
        let finishedlength;
        let finishedheight;
        let calculatedFabricYardsNeeded = 0;


        finishedwidth = parseFloat(inputProductWidth);
        finishedlength = parseFloat(inputProductLength);
        finishedheight = parseFloat(inputProductHeight);

        inchesNeeded = (((finishedheight * finishedwidth * 2) + (finishedheight * finishedlength * 2) + (finishedwidth * finishedlength)) / 144);
    
        neededYardsPrecise = (inchesNeeded / 36);
        neededYardsEstimated = self.roundUpToNearest(neededYardsPrecise, 0.5);
        calculatedFabricYardsNeeded = neededYardsEstimated;

        console.log('neededYardsPrecise ' + neededYardsPrecise);
        console.log('neededYardsEstimated ' + neededYardsEstimated);
        
        return calculatedFabricYardsNeeded;
        */
    const self = this;

    let edgeAllowance = 0.5;
    let quantity = inputProductQuantity;
    let include = "Full Cushion";
    let zipperSliderQty = inputProductQuantity;
    let fabricWidth = parseFloat(inputMaterialFabricWidth);
    let orientation = "Width";

    let numOfPlates;
    let plaqueLength;
    let boxingWidth;
    let boxingLength;
    let plaquewidth;
    let binding;
    let StraightCutAdditionalFabric;
    let bindingSource;
    let inchesPlate;
    let inchesPlaque;
    let inchesBoxing;
    let howManyPlatesCanFit;
    let howManyPlateSections;
    let inchesNeeded;
    let plates;
    let totalPlate;
    let neededYardsPrecise;
    let neededYardsEstimated;

    let finishedwidth;
    let finishedlength;
    let finishedHeight;
    let calculatedFabricYardsNeeded = 0;

    //console.log(inputProductPillowType + '|width is ' + inputProductWidth + '|length is ' + inputProductLength + '|height is ' + inputProductHeight);
    finishedwidth = parseFloat(inputProductWidth);
    finishedlength = parseFloat(inputProductLength);
    finishedHeight = parseFloat(inputProductHeight);

    let foamWidth = finishedwidth + edgeAllowance;
    let foamLength = finishedlength + edgeAllowance;

    switch (include) {
        case "Full Cushion":

            numOfPlates = parseInt(quantity) * 1;
            plaqueLength = Math.round(parseInt(quantity) * (parseFloat(finishedlength) + 2));
            boxingWidth = parseFloat(finishedHeight) + edgeAllowance;
            boxingLength = Math.round(
                ((parseInt(quantity) * (((parseFloat(finishedwidth) * 2) + parseFloat(finishedlength)) + (4 * edgeAllowance)))) * 1.05
            );
            plaquewidth = boxingWidth + 1.25;
            binding = Math.round(
                2 * (parseInt(quantity) * ((parseFloat(finishedwidth) + parseFloat(finishedlength)) * 2))
            ) * 1.05;
            StraightCutAdditionalFabric = Math.round(binding / fabricWidth) * 1.75;
            bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

            if (orientation === 'Width') {
                howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedlength));
                if (howManyPlatesCanFit < 1) {
                    howManyPlatesCanFit = fabricWidth / parseFloat(finishedlength);
                }
                howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                inchesNeeded = howManyPlateSections * parseFloat(finishedwidth);
            } else {
                howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedwidth));
                if (howManyPlatesCanFit < 1) {
                    howManyPlatesCanFit = fabricWidth / parseFloat(finishedwidth);
                }
                howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                inchesNeeded = howManyPlateSections * parseFloat(finishedlength);
            }

            inchesPlate = inchesNeeded;
            inchesNeeded += Math.ceil(plaqueLength / fabricWidth) * plaquewidth;
            inchesPlaque = inchesNeeded;
            inchesNeeded += Math.ceil(boxingLength / fabricWidth) * boxingWidth;
            inchesBoxing = inchesNeeded;

            break;

        case "One Plate & Boxing":

            numOfPlates = parseInt(quantity) * 1;
            plaqueLength = Math.round(parseInt(quantity) * (parseFloat(finishedlength) + 1.25));
            boxingWidth = parseFloat(thickness) + edgeAllowance;
            boxingLength = Math.round(
                ((parseInt(quantity) * (((parseFloat(finishedwidth) * 2) + parseFloat(finishedlength)) + (4 * edgeAllowance)))) * 1.05
            );
            plaquewidth = boxingWidth + 1.25;
            binding = Math.round(1 * (parseInt(quantity) * ((parseFloat(finishedwidth) + parseFloat(finishedlength)) * 2))) * 1.05;
            StraightCutAdditionalFabric = Math.round(binding / fabricWidth) * 1.75;
            bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

            if (orientation === 'Width') {
                howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedlength));
                if (howManyPlatesCanFit < 1) {
                    howManyPlatesCanFit = fabricWidth / parseFloat(finishedlength);
                }
                howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                inchesNeeded = howManyPlateSections * parseFloat(finishedwidth);
            } else {
                howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedwidth));
                if (howManyPlatesCanFit < 1) {
                    howManyPlatesCanFit = fabricWidth / parseFloat(finishedwidth);
                }
                howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                inchesNeeded = howManyPlateSections * parseFloat(finishedlength);
            }

            inchesPlate = inchesNeeded;
            inchesNeeded += Math.ceil(plaqueLength / fabricWidth) * plaquewidth;
            inchesPlaque = inchesNeeded;
            inchesNeeded += Math.ceil(boxingLength / fabricWidth) * boxingWidth;
            inchesBoxing = inchesNeeded;

            break;
    }

    plates = numOfPlates === 1 ? " plate" : " plates";
    totalPlate = numOfPlates + plates;
    neededYardsPrecise = (inchesNeeded / 36);
    neededYardsEstimated = self.roundUpToNearest(neededYardsPrecise, 0.5);
    calculatedFabricYardsNeeded = neededYardsEstimated;

    //if(console){
    //console.log('neededYardsPrecise ' + neededYardsPrecise);
    //console.log('neededYardsEstimated ' + neededYardsEstimated);
    //}

    return calculatedFabricYardsNeeded;
};


//}); // end wait for ready